import { Box, Typography } from '@mui/material';

export default function HowItem({ title, description, Icon }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
      <Box
        sx={{
          minHeight: '60px',
          maxHeight: '60px',
          minWidth: '60px',
          maxWidth: '60px',
          borderRadius: '30px',
          backgroundColor: 'primary.main',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icon sx={{ fontSize: '29px', color: '#fff' }} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1E1E1E',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: '16px',
            color: '#1E1E1E',
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
